<template>
  <div>
        <template v-if="$route.name === 'assignments.index'">
 <AssignmentFilters 
  @search="handleSearch"
  @add="navigateToAdd"
  @filter-by-class="handleClassFilter"
  @filter-by-subject="handleSubjectFilter"
  @filter-by-teacher="handleTeacherFilter"
  @reset-filters="handleResetFilters"
  @filter-by-group="handleGroupFilter"
/>
    <AssignmentTable
      :assignments="assignments"
      :loading="isLoading"
      @delete-assignment="openDeleteDialog"
    />
    
    <PaginationControls
      v-if="pagination.totalItems > 0"
      :pagination="pagination"
      @page-changed="handlePageChange"
      @per-page-changed="handlePerPageChange"
    />
    
     <DeleteAssignmentDialog ref="deleteDialog" @delete="handleDeleteAssignment" />
</template>
    <router-view></router-view>
  </div>
</template>

<script setup>
import { computed, onMounted, ref } from 'vue';
import { useRouter } from 'vue-router';
import { useToast } from 'vue-toastification';
import { useStore } from 'vuex';
import AssignmentTable from '@/components/features/assignments/AssignmentTable.vue';
import AssignmentFilters from '@/components/features/assignments/AssignmentFilters.vue';
import DeleteAssignmentDialog from '@/components/features/assignments/dialogs/DeleteAssignmentDialog.vue';
import PaginationControls from '@/components/common/PaginationControls.vue';

const router = useRouter();
const toast = useToast();
const store = useStore();
const deleteDialog = ref(null);

// Getters
const assignments = computed(() => store.getters['assignments/assignments']);
const isLoading = computed(() => store.getters['assignments/isLoading']);
const pagination = computed(() => store.getters['assignments/pagination']);

const fetchAssignments = (page = 1, perPage = 10) => {
  store.dispatch('assignments/fetchAssignments', { page, per_page: perPage });
};
const handleClassFilter = (classId) => {
  store.dispatch('assignments/setFilters', { 
    ...store.state.assignments.filters,
    class_id: classId
  });
  fetchAssignments(1, pagination.value.perPage);
};

const handleResetFilters = () => {
  store.commit('assignments/SET_FILTERS', {
    search: "",
    class_id: null,
    group_id: null,
    subject_id: null,
    teacher_id: null
  });
  fetchAssignments(1, pagination.value.perPage);
};
const handleSearch = (term) => {
  store.dispatch('assignments/setFilters', { 
    search: term,
    subject_id: store.state.assignments.filters.subject_id,
    teacher_id: store.state.assignments.filters.teacher_id
  });
  fetchAssignments(1, pagination.value.perPage);
};

const handleSubjectFilter = (subjectId) => {
  store.dispatch('assignments/setFilters', { 
    search: store.state.assignments.filters.search,
    subject_id: subjectId,
    teacher_id: store.state.assignments.filters.teacher_id
  });
  fetchAssignments(1, pagination.value.perPage);
};

const handleTeacherFilter = (teacherId) => {
  store.dispatch('assignments/setFilters', { 
    search: store.state.assignments.filters.search,
    subject_id: store.state.assignments.filters.subject_id,
    teacher_id: teacherId
  });
  fetchAssignments(1, pagination.value.perPage);
};

const handlePageChange = (page) => {
  fetchAssignments(page, pagination.value.perPage);
};

const handlePerPageChange = (perPage) => {
  fetchAssignments(1, perPage);
};

const openDeleteDialog = (assignment) => {
  deleteDialog.value?.open(assignment);
};
const handleDeleteAssignment = async (assignmentId) => {
  try {
    await store.dispatch('assignments/deleteAssignment', assignmentId);
    toast.success("تم حذف الواجب بنجاح");
    fetchAssignments(pagination.value.currentPage, pagination.value.perPage);
  } catch (error) {
    toast.error(error.response?.data?.message || "فشل في حذف الواجب");
  }
};

const navigateToAdd = () => {
  router.push({ name: 'assignments.create' });
};

onMounted(() => {
  fetchAssignments();
});
</script>